import React, { useState } from 'react';

const LanguageSwitcher = ({ currentLanguage, onLanguageChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'ru', name: 'Русский', flag: '🇷🇺' },
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
        { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
        { code: 'da', name: 'Dansk', flag: '🇩🇰' }
    ];

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-dark-card border border-gray-800 hover:border-neon-red transition-colors"
            >
                <span>{languages.find(lang => lang.code === currentLanguage)?.flag}</span>
                <span className="hidden sm:inline">
          {languages.find(lang => lang.code === currentLanguage)?.name}
        </span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <>
                    <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
                    <div className="absolute right-0 mt-2 w-48 rounded-lg shadow-lg bg-dark-card border border-gray-800 z-20">
                        <div className="py-1">
                            {languages.map((language) => (
                                <button
                                    key={language.code}
                                    onClick={() => {
                                        onLanguageChange(language.code);
                                        setIsOpen(false);
                                    }}
                                    className={`flex items-center w-full px-4 py-2 text-left hover:bg-gray-900 transition-colors ${
                                        currentLanguage === language.code ? 'text-neon-red' : 'text-gray-300'
                                    }`}
                                >
                                    <span className="mr-2">{language.flag}</span>
                                    {language.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LanguageSwitcher;